/**
 * @generated SignedSource<<2265ae4918958c6f3e5ea4d2e6b82f3d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useUXSimplificationFeatureLatestRecordingQuery$variables = {};
export type useUXSimplificationFeatureLatestRecordingQuery$data = {
  readonly viewer: {
    readonly recordingsAndClips: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id?: string;
          readonly url?: string | null;
        };
      }>;
    };
  };
};
export type useUXSimplificationFeatureLatestRecordingQuery = {
  response: useUXSimplificationFeatureLatestRecordingQuery$data;
  variables: useUXSimplificationFeatureLatestRecordingQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "entityType",
    "value": "recordings"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUXSimplificationFeatureLatestRecordingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "MeetingRecordingConnection",
            "kind": "LinkedField",
            "name": "recordingsAndClips",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/)
                        ],
                        "type": "MeetingRecording",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "recordingsAndClips(entityType:\"recordings\",first:1)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useUXSimplificationFeatureLatestRecordingQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v0/*: any*/),
            "concreteType": "MeetingRecordingConnection",
            "kind": "LinkedField",
            "name": "recordingsAndClips",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v2/*: any*/)
                        ],
                        "type": "MeetingRecording",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "recordingsAndClips(entityType:\"recordings\",first:1)"
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f01336bb6eb839b06c344dc6ff4e4032",
    "id": null,
    "metadata": {},
    "name": "useUXSimplificationFeatureLatestRecordingQuery",
    "operationKind": "query",
    "text": "query useUXSimplificationFeatureLatestRecordingQuery {\n  viewer {\n    recordingsAndClips(first: 1, entityType: recordings) {\n      edges {\n        node {\n          __typename\n          ... on MeetingRecording {\n            id\n            url\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "830c4c40733944103fe1dbb92256f814";

export default node;
